import React from 'react';
import { DateInput } from 'semantic-ui-calendar-react';
import isEmpty from 'lodash/isEmpty'
import { dateToStr, format } from '../../utilities/date'
import { css } from 'emotion'

export default function DateSelector({
  error,
  disabled,
  label,
  selected,
  onChange,
  dateFormat,
}) {
  const date = isEmpty(selected) ? dateToStr(new Date, dateFormat) : selected
  const className = `${style} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`

  return (
    <div className={className}>
      <DateInput
        popupPosition='bottom right'
        label={label || ''}
        dateFormat={dateFormat || format}
        name='date'
        value={date}
        iconPosition='left'
        preserveViewMode={true}
        autoComplete='off'
        onChange={onChange} />
    </div>
  )
}

const style = css`
  & {
    clear: both;
    margin: 0 0 1em;

    .field > .input > input[name="date"] {
      border-radius: '';
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  }

  &.error {
    label {
      color: #9f3a38;
    }
  
    .field > .input > input[name="date"] {
      background: #fff6f6;
      border-color: #e0b4b4;
      color: #9f3a38;
    }
  }

  &.disabled {
    pointer-events: none;
    opacity: .9;
  }
    
  }
`



// WEBPACK FOOTER //
// ./components/custom/DateSelector.js